import { render, staticRenderFns } from "./SingleServiceOrderChip.vue?vue&type=template&id=8123afde&"
import script from "./SingleServiceOrderChip.vue?vue&type=script&lang=js&"
export * from "./SingleServiceOrderChip.vue?vue&type=script&lang=js&"
import style0 from "./SingleServiceOrderChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8123afde')) {
      api.createRecord('8123afde', component.options)
    } else {
      api.reload('8123afde', component.options)
    }
    module.hot.accept("./SingleServiceOrderChip.vue?vue&type=template&id=8123afde&", function () {
      api.rerender('8123afde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/SingleServiceOrderChip.vue"
export default component.exports